import { useTranslation } from 'next-i18next/pages';

import { SOLUTION_RESOURCE_PRODUCT_ORDER } from '@/data/shared/solutionResources';

import Area from '@/components/apps/layouts/shared/Area';
import Subtop from '@/components/apps/ui/subtop/Subtop';
import { AniSlideUp } from '@/components/shared/animations/basic';

import ResourceProductGroup from './ResourceProductGroup';

const DESCRIPTION_CLASS =
  'leading-[140%] tracking-[-0.32px] text-apps-brandGray200 lg:text-[20px] lg:leading-[160%] lg:tracking-[-0.4px]';

/**
 * ### AboutResources
 *
 * The resource page body: solution overviews and brochures grouped by the
 * product they describe. The listing is driven by the shared resource data, so
 * it stays in step with the same list on the solution components page.
 */
export default function AboutResources() {
  const { t } = useTranslation('common');

  return (
    <div className="subtop-wave-bg">
      <Subtop title={t('자료실')} />

      <Area>
        <div className="pt-[24px] lg:pt-[32px]">
          <AniSlideUp>
            <p className={DESCRIPTION_CLASS}>
              {t(
                '디플리의 솔루션 등 다양한 자료를 다운로드 받으실 수 있습니다.',
              )}
            </p>
          </AniSlideUp>
        </div>

        <div className="mt-[40px] flex flex-col gap-[48px] lg:mt-[clamp(40px,5vw,60px)] lg:gap-[clamp(48px,6vw,80px)]">
          {SOLUTION_RESOURCE_PRODUCT_ORDER.map((product) => (
            <ResourceProductGroup key={product} product={product} />
          ))}
        </div>
      </Area>
    </div>
  );
}
